export default {
    _prefix: "ai.scoring",
    labels: {
        aiSuggested: "AI Suggested",
        reason: "Reason for Selection",
        reasonUnavailable:
            "This question was answered by AI Scoring, but the reason for selection is not available",
    },
};
